import { makeStyles, Theme, fade } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginTop:20,
    // marginBottom: 20,
    marginRight:20,
    display: 'flex',
    justifyContent: 'space-between',
    width: 'calc(100% - 350px)',
    marginLeft: 340,
  },
  closedcontainer: {
    width: 'calc(100% - 143px)',
    marginLeft: 120,
  },
  icon :{
    margin:0
  },
  btnmenu :{
    minWidth:200,
    height:50,
    backgroundColor: 'white !important',
    color: 'black !important',
    borderRadius: '8px !important',
    boxShadow: 'none !important',
    border: '1px solid #A2A1A8 !important',
    textTransform: 'capitalize',
    fontWeight: 300,
    borderColor: 'rgba(162, 161, 168, 0.2) !important'
  },
  menuroot:{
    width: '200px !important',
  },
  separator: {
    margin:'0 !important'
  }
}));

export default useStyles;
